import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
  },

  contentCard: {
    width: "40%",
    minWidth: 200,
    alignSelf: "center",
    borderWidth: 0.5,
    borderColor: "#077A97",
    borderRadius: 8,
    marginTop: 10,
    marginBottom: 10,
    flexDirection: "column",
    alignItems: "left",
    paddingHorizontal: 16,
    paddingVertical: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  walletTitleContainer: {
    marginTop: 85,
    marginBottom: 36,
    flex: 1,
  },

  tituloWallet: {
    fontSize: 28,
    color: "#000000",
    fontWeight: "bold",
  },

  textCoinGpx: {
    fontSize: 24,
    textAlign: "center",
    fontWeight: "bold",
  },

  textCoinBrl: {
    fontSize: 24,
    fontWeight: "500",
    textAlign: "left",
  },

  headerContainer: {
    marginTop: 20,
    alignSelf: "center",
    minWidth: "44%",
  },

  textMyMoney: {
    textTransform: "uppercase",
    textAlign: "left",
    fontSize: 14,
    fontWeight: "500",
    marginBottom: 10,
  },

  contentPageTab: {
    paddingHorizontal: 25,
    marginBottom: 20,
  },

  tabText: {
    color: "#7E7979",
    textTransform: "uppercase",
    fontSize: 16,
  },
  activeButtonText: {
    color: "#077A97",
    textTransform: "uppercase",
    fontSize: 16,
  },

  containerBtnsCarteira: {
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 20,
    flex: 1,
  },
});

export default styles;
